const FromArr = [{
	title: "产品线：",
	inputtype: "select",
	inputflag: true,
	fontSize: 14,
	color: "#333333",
	lableheight: 20,
	X: false,
	types: "",
	placeholder: "请选择",
	width: 160,
	height: 32,
	disabled: false,
	marginLeft: 24,
	marginTop: 28,
	displayVal: "inline-block",
	fontWeightVal: 500,
	options: []
}, {
	title: "唯一码：",
	inputtype: "input",
	inputflag: true,
	fontSize: 14,
	color: "#333333",
	lableheight: 20,
	X: false,
	types: "",
	placeholder: "请输入",
	width: 160,
	height: 32,
	disabled: false,
	marginLeft: 24,
	marginTop: 20,
	displayVal: "inline-block",
	fontWeightVal: 500
}, {
	title: "产品型号/名称：",
	inputtype: "input",
	inputflag: true,
	fontSize: 14,
	color: "#333333",
	lableheight: 20,
	X: false,
	types: "",
	placeholder: "请输入",
	width: 160,
	height: 32,
	disabled: false,
	marginLeft: 24,
	marginTop: 20,
	displayVal: "inline-block",
	fontWeightVal: 500
}, {
	title: "批号：",
	inputtype: "input",
	inputflag: true,
	fontSize: 14,
	color: "#333333",
	lableheight: 20,
	X: false,
	types: "",
	placeholder: "请输入",
	width: 160,
	height: 32,
	disabled: false,
	marginLeft: 24,
	marginTop: 20,
	displayVal: "inline-block",
	fontWeightVal: 500
}, {
	title: "经销商：",
	inputtype: "select",
	inputflag: true,
	fontSize: 14,
	color: "#333333",
	lableheight: 20,
	X: false,
	types: "",
	placeholder: "请选择",
	width: 180,
	height: 32,
	disabled: false,
	marginLeft: 24,
	marginTop: 28,
	displayVal: "inline-block",
	fontWeightVal: 500,
	options: []
}]
export default FromArr;